/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import {
    REQUEST_LEARNING_LOOP_PACKETS,
    RECEIVE_LEARNING_LOOP_PACKETS,
    EXPORT_LEARNING_LOOP_PACKETS,
    CLEAR_STATE,
    RECEIVE_GENERAL,
    FILTER_CHANGED,
    REQUEST_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT, RECEIVE_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT
} from "./LearningLoopActions";

import {ACTION_TYPES} from "./LearningLoopConst";

const initialState = {
    error: null,
    loading: false,
    learningLoopData: {},
    notExportedPacketsCount: 0,
    filter: {
        start: 1,
        limit: 10,
        exportedStates: [ACTION_TYPES.NOT_EXPORTED],
    },
    open: false,
    password: '',
    connectorMessage: '',
}

export const learningLoopReducer = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_LEARNING_LOOP_PACKETS:
        case EXPORT_LEARNING_LOOP_PACKETS:
            return {
                ...state,
                loading: true,
            }
        case RECEIVE_LEARNING_LOOP_PACKETS:
            return {
                ...state,
                loading: false,
                learningLoopData: action.learningLoopData,
                error: null,
            }
        case REQUEST_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT:
            return {
                ...state,
            }
        case RECEIVE_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT:
            return {
                ...state,
                notExportedPacketsCount: action.notExportedPacketsCount,
            }
        case RECEIVE_GENERAL :
            return {
                ...state,
                loading: false,
            }
        case FILTER_CHANGED:
            return {
                ...state,
                filter: action.filter,
            }
        case CLEAR_STATE:
            return initialState
        default:
            return state
    }
}